import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}

function SLLogoIcon({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      width="145"
      height="75"
      viewBox="0 0 145 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5 19C35.1193 19 34 20.1193 34 21.5C34 22.8807 35.1193 24 36.5 24H76.5V27H36.5C33.4624 27 31 24.5376 31 21.5C31 18.4624 33.4624 16 36.5 16H76.5V19H36.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5 50.5C29.8807 50.5 31 51.6193 31 53C31 54.3807 29.8807 55.5 28.5 55.5H0.5V58.5H28.5C31.5376 58.5 34 56.0376 34 53C34 49.9624 31.5376 47.5 28.5 47.5H0.5V50.5H28.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.5 3H32.5C22.2827 3 14 11.2827 14 21.5C14 31.7173 21.2827 40 31.5 40C38.9558 40 44 46.0442 44 53.5C44 60.9558 37.9558 67 30.5 67H0.5V64H30.5C36.299 64 41 59.299 41 53.5C41 47.701 37.299 43 31.5 43H0.5V40H20.8034C14.7898 36.2534 11 29.3706 11 21.5C11 9.62588 20.6259 0 32.5 0H110.5V3ZM72.5 35H44.1967C50.2102 38.7466 54 45.6294 54 53.5C54 65.3741 44.3741 75 32.5 75H0.5V72H32.5C42.7173 72 51 63.7173 51 53.5C51 43.2827 43.7173 35 33.5 35L31.5 34.8493C25.1563 33.8727 21 28.268 21 21.5C21 14.0442 27.0442 8 34.5 8H75.5V11H34.5C28.701 11 24 15.701 24 21.5C24 27.299 27.701 32 33.5 32H72.5V35Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.499999 72L0.5 41L3.5 41L3.5 72L0.499999 72Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83 67L83 -1.31134e-07L86 0L86 67L83 67Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75 59L75 -1.31134e-07L78 0L78 59L75 59Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142 75L142 56L145 56L145 75L142 75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.5 0H94.5V72H144V75H91.5V0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5 35C62.2827 35 54 43.2827 54 53.5C54 63.7173 62.2827 72 72.5 72H92.5V75H72.5C60.6259 75 51 65.3741 51 53.5C51 41.6259 60.6259 32 72.5 32H76.5V35H72.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5 43C66.701 43 62 47.701 62 53.5C62 59.299 66.701 64 72.5 64H85.5V67H72.5C65.0442 67 59 60.9558 59 53.5C59 46.0442 65.0442 40 72.5 40H77.5V43H72.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5 51C71.1193 51 70 52.1193 70 53.5C70 54.8807 71.1193 56 72.5 56H77.5V59H72.5C69.4624 59 67 56.5376 67 53.5C67 50.4624 69.4624 48 72.5 48H77.5V51H72.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.5 0H102.5V64H144V67H99.5V0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.5 0H110.5V56.0053H145V59.0053H107.5V0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export { SLLogoIcon as ReactComponent }
